// Callback.js

import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // If you're using React Router

const Authenticated = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Extract the grant token from the URL or Zoho response data
    const params = new URLSearchParams(window.location.search);
   //const code = params.get('code');
    const accessToken = params.get("token");
    const expiresIn = params.get('expires_in');
    const state = params.get('state');
    console.log("Redirect State is: ",state);
    console.log("Access Token: ", accessToken);
    if(accessToken) {
        localStorage.setItem('access_token',accessToken);
        localStorage.setItem('expires_in',expiresIn);
        const expirationTime = Date.now() + expiresIn * 1000; // Calculate expiration time in milliseconds
        localStorage.setItem('token_time', expirationTime);
        navigate('/'+state);
    }

  }, [location, navigate]);
    return (
    <div>
      <p>Handling Zoho response...</p>
    </div>
  );
};

export default Authenticated;
